import { environment } from '@env/environment';

declare global {
  interface Window {
    __APP_CONFIG__?: {
      apiUrl?: string;
    };
  }
}

export function getApiBaseUrl(): string {
  return window.__APP_CONFIG__?.apiUrl || environment.apiUrl;
}
